var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('banner-slider'),_c('home-describe'),_c('home-case'),_c('comm-news'),_c('contact-us')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }